import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LexgosignEnvelope, LexgosignRecipient, LexgosignService } from '@services/lexgosign.service';

@Component({
  selector: 'app-lexgosign-progress',
  templateUrl: './lexgosign-progress.component.html',
  styleUrls: ['./lexgosign-progress.component.scss'],
  standalone: false
})
export class LexgosignProgressComponent implements OnInit {
  @Input() envelopePk: string | number;
  @Input() envelopeName = '';

  loading = true;
  errorMessage = '';
  progress: LexgosignEnvelope | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private lexgosignService: LexgosignService
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;
    this.errorMessage = '';
    this.lexgosignService.progress(this.envelopePk).subscribe(
      (data) => {
        this.progress = data;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.errorMessage =
          err?.error?.message || err?.message || 'No se pudo cargar el progreso';
      }
    );
  }

  statusLabel(status: string): string {
    const st = (status || '').toUpperCase();
    // Envelope (misma lógica que grilla / detalle requerimiento)
    if (st === 'CREATED' || st === 'SENDING' || st === 'ERROR') return 'Pendiente';
    if (st === 'SENT' || st === 'IN_PROGRESS') return 'En Firma';
    if (st === 'SUCCESS') return 'Firmado';
    if (st === 'VOIDED') return 'Anulado';
    // Recipient
    if (st === 'SIGNED') return 'Firmado';
    if (st === 'REJECTED') return 'Rechazado';
    if (st === 'PENDING') return 'Pendiente';
    if (st === 'EMAIL_SENT' || st === 'EMAIL_RECEIVED' || st === 'EMAIL_OPENED') {
      return 'En Firma';
    }
    return status || '';
  }

  recipients(): LexgosignRecipient[] {
    return Array.isArray(this.progress?.recipients) ? this.progress.recipients : [];
  }

  close() {
    this.activeModal.close(this.progress);
  }
}
